/** Property records contain legacy lat/lon rings or standard GeoJSON lon/lat. */
export function environmentBounds(boundary) {
 try {
  let geometry=typeof boundary==='string'?JSON.parse(boundary):boundary;
  if(geometry?.type==='Feature')geometry=geometry.geometry;
  if(geometry?.type&&!['Polygon','MultiPolygon'].includes(geometry.type))return null;
  const points=[];
  const walk=value=>{
   if(!Array.isArray(value))return;
   if(typeof value[0]==='number'){
    const [lat,lon]=geometry?.type?[value[1],value[0]]:value;
    if(!Number.isFinite(lat)||!Number.isFinite(lon)||Math.abs(lat)>80||Math.abs(lon)>180)throw Error('Invalid boundary');
    points.push([lat,lon]);
   }else value.forEach(walk);
  };
  walk(geometry?.coordinates??geometry);
  if(points.length<3)return null;
  const south=Math.min(...points.map(p=>p[0])),north=Math.max(...points.map(p=>p[0]));
  const west=Math.min(...points.map(p=>p[1])),east=Math.max(...points.map(p=>p[1]));
  const lat=(south+north)/2,lon=(west+east)/2,longitudeKm=111.195*Math.cos(lat*Math.PI/180);
  // Keep this property service bounded; never turn panning into global weather requests.
  if((north-south)*111.195>5||(east-west)*longitudeKm>5||north===south||west===east)return null;
  return {center:[lat,lon],propertyBounds:[[south,west],[north,east]],bounds:[[south-3/111.195,west-3/longitudeKm],[north+3/111.195,east+3/longitudeKm]]};
 }catch{return null;}
}
export function pointInWeatherCell(lat,lon,ring){
 let inside=false;
 for(let i=0,j=ring.length-1;i<ring.length;j=i++){
  const [x,y]=ring[i],[px,py]=ring[j];
  if((y>lat)!==(py>lat)&&lon<(px-x)*(lat-y)/(py-y)+x)inside=!inside;
 }
 return inside;
}
